export const SET_REMOTE_ARTICLES = "SET_REMOTE_ARTICLES";

export const SET_REMOTE_CATEGORIES = "SET_REMOTE_CATEGORIES";

export const SET_ARTICLE_LOADER = "SET_ARTICLE_LOADER";

export const SET_CATEGORY_LOADER_STATUS = "SET_CATEGORY_LOADER_STATUS";

export const SET_CATEGORY_ID = "SET_CATEGORY_ID";

export const SET_ARTICLE_SEARCH_QUERY = "SET_ARTICLE_SEARCH_QUERY";

export const SET_TEXT_SEARCH = "SET_TEXT_SEARCH";

export const SET_CATEGORY_SEARCH = "SET_CATEGORY_SEARCH";
